import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { monitoraActions } from '../../../store/monitoraStore'
import BbDatePicker from '../../common/datePicker';

class MonitoraFilters extends React.Component {
    state = {
        dateFrom: null,
        dateTo: null
    };

    dateChange(prefix, day) {
        if(moment(day, "l", true).isValid())
            this.setState({ [prefix]: moment(day, "l").format("YYYY-MM-DD") });
        else if(moment(day, "L", true).isValid()) 
            this.setState({ [prefix]: moment(day, "L").format("YYYY-MM-DD") });
        else if(day === "")
            this.setState({ [prefix]: null });
    }

    render() {
        return (
            <>
                <div style={{ marginBottom: "1em" }}><Translate id="Report.Monitora.ReportsPublishedDuring" /></div>
                <div className='field bb-field'>
                    <div className="columns">
                        <div className="column is-12 date-picker-overlay-reversed-direction">
                            <BbDatePicker enableReinitialize
                                afterDateChange={d => this.dateChange("dateFrom", d)}
                                value={this.state.dateFrom}
                                formDateFormat="YYYY-MM-DD"
                                rightPanel={true}
                                placeholder={this.props.translate("Common.From")}
                                yearsBack={120}
                            />
                        </div>
                    </div>
                </div>
                <div className='field bb-field' style={{ marginBottom: "0" }}>
                    <div className="columns">
                        <div className="column is-12 date-picker-overlay-reversed-direction">
                            <BbDatePicker enableReinitialize
                                afterDateChange={d => this.dateChange("dateTo", d)}
                                value={this.state.dateTo}
                                formDateFormat="YYYY-MM-DD"
                                rightPanel={true}
                                placeholder={this.props.translate("Common.To")}
                                yearsBack={120}
                            />
                        </div>
                    </div>
                </div>
                <div className="buttons" style={{ paddingBottom: '.5em', justifyContent: 'center', paddingTop: "1.5em" }}>
                    <button
                        className={classnames('bb-button small gradient-1', {'is-square': localStorage.locales_button_style === 'square'})}
                        onClick={() => this.props.getAnnotations(this.props.id, this.state.dateFrom, this.state.dateTo)}
                    >
                        <Translate id='Report.EconomicGroup.Settings.SetBtn' />
                    </button>
                </div>
            </>
        );
    }

    componentDidMount() {
        this.setState({
            dateFrom: this.props.monitora.settings.dateFrom,
            dateTo: this.props.monitora.settings.dateTo
        });
    }
}

export default withLocalize(connect(
    state => ({ ...state.report, monitora: state.monitora }),
    dispatch => bindActionCreators(monitoraActions, dispatch)
)(MonitoraFilters));